import { ModalContext } from "../../components/BrowserAlert/modalContext";
import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Divider,
  Stack,
  Autocomplete,
  Tooltip,
  InputAdornment,
  InputLabel,
  Skeleton,
  Checkbox,
} from "@common-ui/ui";
import { useHistory, useParams } from "react-router-dom";
import { Business, Tv, Info, AlternateEmail } from "@mui/icons-material";

import { countries, createSubOrg } from "../../services";
import { getOrg } from "../../services";
import AlertDialog from "./AlertDialog";
export const CreateSubOrgForm = () => {
  let { handleModal } = React.useContext(ModalContext);
  let router = useHistory();
  let params = useParams();
  const [open, setOpen] = React.useState(false);
  const [countryHistory, setCountryHistory] = useState(null);
  const [currentOrgId, setCurrentOrgId] = React.useState(-1);
  const [parentOrg, setParentOrg] = useState(null);

  React.useEffect(() => {
    async function init() {
      try {
        let payload = await getOrg(params.orgId);
        setParentOrg(payload);
      } catch (error) {}
    }
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickOpen = (orgId = -1) => {
    setCurrentOrgId(orgId);
    setOpen(true);
  };

  const handleClose = () => {
    router.push({
      pathname: `/orgs/${currentOrgId}/edit`,
    });
    setOpen(false);
  };
  const formik = useFormik({
    initialValues: {
      orgName: "",
      orgHandle: "",
      orgType: null,
      orgDisplayName: "",
      orgCountryOrRegion: null,
      isParentStreetAddress: false,
      isParentContact: false,
    },
    validationSchema: Yup.object({
      orgName: Yup.string().trim().max(255).required("Name is required"),
      orgHandle: Yup.string().trim().max(255).required("Handle is required"),
      orgDisplayName: Yup.string().trim().max(255),
      orgCountryOrRegion: Yup.object()
        .nullable()
        .required("Country / Region is required"),
      orgType: Yup.object().nullable(),
      isParentStreetAddress: Yup.boolean(),
      isParentContact: Yup.boolean(),
    }),
    onSubmit: () => {
      async function submit() {
        let {
          orgName,
          orgType,
          orgDisplayName,
          orgCountryOrRegion,
          orgHandle,
          isParentStreetAddress,
          isParentContact,
        } = formik.values;
        const attributes = {
          name: orgName,
          handle: orgHandle,
          // parent: parentOrg.id,
          type: orgType?.label,
          screen_name: orgDisplayName,
          street_address: isParentStreetAddress
            ? parentOrg.street_address
            : {
                address_line_1: " ",
                address_line_2: " ",
                city: " ",
                state_or_province: " ",
                country_or_region: orgCountryOrRegion?.label,
                postal_code: " ",
              },
          shipping_address: isParentStreetAddress
            ? parentOrg?.shipping_address
            : null,
          support_email: isParentContact ? parentOrg?.support_email : undefined,
          support_phone: isParentContact ? parentOrg?.support_phone : undefined,
          website: isParentContact ? parentOrg?.website : undefined,
          linkedin: isParentContact ? parentOrg?.linkedin : undefined,
          facebook: isParentContact ? parentOrg?.facebook : undefined,
          twitter: isParentContact ? parentOrg?.twitter : undefined,
          youtube: isParentContact ? parentOrg?.youtube : undefined,
        };
        try {
          const { payload } = await onSubmit(attributes, parentOrg.id);
          const orgId = payload;
          handleClickOpen(orgId);
        } catch (error) {
          handleModal(
            `The handle "${orgHandle}" is already in use; Please use a different handle!"`,
            "Error"
          );
          formik.setSubmitting(false);
        }
      }
      submit();
    },
  });
  const renderOrg = (org) => {
    return org?.screen_name && String(org?.screen_name).trim() !== ""
      ? org?.screen_name
      : org?.name;
  };

  const onSubmit = async (attributes, parentOrgId) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const payload = await createSubOrg(attributes, parentOrgId);
        /* Once the user successfully signs up, update form state to show the confirm sign up form for MFA */
        resolve({ payload: payload?.id });
      } catch (error) {
        reject(error);
      }
    });
  };
  React.useEffect(() => {
    if (formik.values.isParentStreetAddress) {
      setCountryHistory(formik.values.orgCountryOrRegion);
      formik.setFieldValue(
        "orgCountryOrRegion",
        Array.from(countries).find(
          (opt) => opt.label === parentOrg?.street_address?.country_or_region
        )
      );
    } else {
      formik.setFieldValue("orgCountryOrRegion", countryHistory);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.isParentStreetAddress]);
  return (
    <>
      <Box
        component="main"
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100%",
          backgroundColor: "#FFFFFF",
          ".MuiDataGrid-virtualScroller": {
            marginTop: "40px !important",
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
          // bgcolor: "background.paper",
        }}
      >
        <Container maxWidth="md" component="main">
          <form onSubmit={formik.handleSubmit}>
            <Box sx={{ my: 3, maxWidth: { md: 300 } }}>
              <Typography color="textPrimary" variant="h4">
                {parentOrg ? renderOrg(parentOrg) : <Skeleton />}
              </Typography>
              <Typography color="textSecondary" gutterBottom variant="body2">
                {parentOrg ? "Add Sub Organization Information" : <Skeleton />}
              </Typography>
            </Box>
            {parentOrg ? (
              <>
                <Stack direction="column" sx={{ maxWidth: { md: 300 } }}>
                  <div>
                    <InputLabel>
                      <span>
                        <svg
                          width="16px"
                          height="16px"
                          viewBox="0 0 16 16"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g fillRule="evenodd">
                            <polygon
                              id="Shape"
                              fill="#EE2E24"
                              fillRule="nonzero"
                              points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                            ></polygon>
                          </g>
                        </svg>
                      </span>
                      Sub Organization Name
                    </InputLabel>
                    <TextField
                      autoComplete="off"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Business />
                          </InputAdornment>
                        ),
                      }}
                      size="small"
                      error={Boolean(
                        formik.touched.orgName && formik.errors.orgName
                      )}
                      fullWidth
                      helperText={
                        formik.touched.orgName && formik.errors.orgName
                      }
                      placeholder="Type"
                      margin="normal"
                      sx={{ mt: 1 }}
                      name="orgName"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.orgName}
                    />
                  </div>
                  <div>
                    <InputLabel sx={{ mt: 1 }}>
                      <svg
                        width="16px"
                        height="16px"
                        viewBox="0 0 16 16"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g fillRule="evenodd">
                          <polygon
                            id="Shape"
                            fill="#EE2E24"
                            fillRule="nonzero"
                            points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                          ></polygon>
                        </g>
                      </svg>
                      @Org_handle{" "}
                      <span>
                        <Tooltip
                          placement="right"
                          title="For use in mentions i.e. @org_handle, you can use any
                    handle that is unique, and can choose to keep it
                    consistent to match your handle on other platforms e.g.
                    twitter."
                        >
                          <Info sx={{ fontSize: 14, color: "#777777" }} />
                        </Tooltip>
                      </span>
                    </InputLabel>
                    <TextField
                      size="small"
                      sx={{ mt: 1 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AlternateEmail />
                          </InputAdornment>
                        ),
                      }}
                      autoComplete="off"
                      error={Boolean(
                        formik.touched.orgHandle && formik.errors.orgHandle
                      )}
                      fullWidth
                      helperText={
                        formik.touched.orgHandle && formik.errors.orgHandle
                      }
                      placeholder="Type"
                      margin="normal"
                      name="orgHandle"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.orgHandle}
                    />
                  </div>
                  <div>
                    <InputLabel sx={{ mt: 1 }}>
                      Display Name
                      <span>
                        <Tooltip
                          placement="right"
                          title="You can use a display name different from your
                        organization name, or you can leave this blank. You can
                        update your display name in your organization profile."
                        >
                          <Info sx={{ fontSize: 14, color: "#777777" }} />
                        </Tooltip>
                      </span>
                    </InputLabel>
                    <TextField
                      sx={{ mt: 1 }}
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tv />
                          </InputAdornment>
                        ),
                      }}
                      autoComplete="off"
                      error={Boolean(
                        formik.touched.orgDisplayName &&
                          formik.errors.orgDisplayName
                      )}
                      fullWidth
                      helperText={
                        formik.touched.orgDisplayName &&
                        formik.errors.orgDisplayName
                      }
                      placeholder="Type"
                      margin="normal"
                      name="orgDisplayName"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      type="orgDisplayName"
                      value={formik.values.orgDisplayName}
                      variant="outlined"
                    />
                  </div>
                  <div>
                    <InputLabel sx={{ mt: 1 }}>
                      {" "}
                      <svg
                        width="16px"
                        height="16px"
                        viewBox="0 0 16 16"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g fillRule="evenodd">
                          <polygon
                            id="Shape"
                            fill="#EE2E24"
                            fillRule="nonzero"
                            points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                          ></polygon>
                        </g>
                      </svg>
                      Country / Region
                    </InputLabel>
                    <Autocomplete
                      disabled={
                        formik.values.isParentStreetAddress ? true : false
                      }
                      id="country-select"
                      sx={{ mt: 1 }}
                      disablePortal
                      ListboxProps={{ style: { maxHeight: "200px" } }}
                      options={countries}
                      autoHighlight
                      size="small"
                      getOptionLabel={(option) => option.label}
                      margin="normal"
                      name="orgCountryOrRegion"
                      limitTags={4}
                      onBlur={formik.handleBlur}
                      onChange={(value, newValue) => {
                        formik.setFieldValue("orgCountryOrRegion", newValue);
                      }}
                      fullWidth
                      value={formik.values.orgCountryOrRegion}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          <img
                            loading="lazy"
                            width="20"
                            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                            alt=""
                          />
                          {option.label} ({option.code}) +{option.phone}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Select"
                          helperText={
                            formik.touched.orgCountryOrRegion &&
                            formik.errors.orgCountryOrRegion
                          }
                          error={Boolean(
                            formik.touched.orgCountryOrRegion &&
                              formik.errors.orgCountryOrRegion
                          )}
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "off", // disable autocomplete and autofill
                          }}
                        />
                      )}
                    />
                  </div>
                </Stack>
                <Stack sx={{ maxWidth: { md: 600 } }}>
                  <Box
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      ml: -1,
                    }}
                  >
                    <Checkbox
                      name="isParentStreetAddress"
                      checked={formik.values.isParentStreetAddress}
                      onChange={formik.handleChange}
                    />
                    <Typography color="textSecondary" variant="body2">
                      {`Inherit Addresses from ${renderOrg(parentOrg)}`}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      ml: -1,
                    }}
                  >
                    <Checkbox
                      name="isParentContact"
                      checked={formik.values.isParentContact}
                      onChange={formik.handleChange}
                    />
                    <Typography color="textSecondary" variant="body2">
                      {`Inherit Contact Information from ${renderOrg(
                        parentOrg
                      )}`}
                    </Typography>
                  </Box>
                  <Divider sx={{ py: 1 }} />
                  <Stack
                    direction={{ xs: "column", md: "row" }}
                    justifyContent="flex-end"
                    spacing={{ xs: 1, md: 2 }}
                    sx={{ py: 2 }}
                  >
                    <div>
                      <Button
                        color="primary"
                        fullWidth
                        size="large"
                        onClick={() => router.goBack()}
                        variant="text"
                      >
                        Cancel
                      </Button>
                    </div>
                    <div>
                      <Button
                        color="primary"
                        disabled={!(formik.isValid && formik.dirty)}
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                      >
                        Save
                      </Button>
                    </div>
                  </Stack>
                </Stack>
              </>
            ) : (
              <Skeleton
                variant="rectangle"
                sx={{ maxWidth: { md: 600 } }}
                height={400}
              />
            )}
          </form>
        </Container>
      </Box>
      <AlertDialog handleClose={handleClose} open={open} />
    </>
  );
};
